import { IStatisticFilters } from 'shared/types/api-types/statistic-type'
import { INIT_PARAMS } from '../components/cards/top-selling'

export const INITIAL_PARAMS: IStatisticFilters = {...INIT_PARAMS, period: 1}